module.exports = __webpack_public_path__ + "54883918b605b9dddaea2a311a6ca6f8.pdf";